import {
    sourceListRequest,
    sourceItemRequest
} from "../../../actions/source-actions"
import buildListContainer from "../../common/build-list-container"
import SourceListItem from "./SourceListItem"
import SourceListItemShadow from "./SourceListItemShadow"

export default buildListContainer(
    SourceListItem,
    SourceListItemShadow,
    sourceListRequest,
    sourceItemRequest,
    "sources"
)
